import { IconButton, makeStyles, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Toolbar, Typography } from '@material-ui/core';
import {AddCircle, Edit, Delete, VisibilityOff, Visibility, Settings, Group, Refresh} from '@material-ui/icons';
import React, {useEffect, useRef, useState} from 'react';
import { useHistory } from 'react-router-dom';
import { operatorRepository } from '../../../Domain/Repositories/OperatorRepository';
import ErrorCardController from "../../UiComponents/ErrorCardController";
import Loading from "../../UiComponents/Loading";
import OperatorSettings from "../../../Domain/Models/OperatorSettings";
import OperatorSettingsModal from "./OperatorSettingsModal";

const useStyles = makeStyles((theme) => ({
  paper: {
    padding: theme.spacing(2),
    marginBottom: theme.spacing(2),
    display: 'flex',
    overflow: 'auto',
    flexDirection: 'column',
  },
  title: {
    flexGrow: 1
  },
  clickableCell: {
    cursor: 'pointer',
  }
}));

export default function OperatorList()
{
  const classes = useStyles();
  const history = useHistory();

  const errorCardControllerRef = useRef<ErrorCardController>(null);

  const [operatorDialogOpen, setOperatorDialogOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [operatorSettings, setOperatorSettings] = useState<OperatorSettings>();

  const handleSettingsClicked = () =>
  {
    setOperatorDialogOpen(true);
  };

  const handleDialogClose = () =>
  {
    setOperatorDialogOpen(false);
    forceReload();
  };

  const forceReload = () =>
  {
    setLoading(true);
    operatorRepository.load()
      .then(() => setLoading(false))
      .catch((e: Error) =>
      {
        setLoading(false);
        errorCardControllerRef.current?.addErrorMessage(e.message);
      })

    setOperatorSettings(undefined);
    operatorRepository.getSettings()
      .then((x) => setOperatorSettings(x))
      .catch((e) =>
      {
      })
  }

  useEffect(() =>
  {
    forceReload();
  }, [])

  return (
    <>
      <OperatorSettingsModal
        open={operatorDialogOpen}
        onClose={handleDialogClose}
      />

      <Loading isLoading={loading}>
        <ErrorCardController ref={errorCardControllerRef}/>

        <Paper className={classes.paper}>
          <Toolbar>
            <Typography className={classes.title} component="h2" variant="h6" color="primary" gutterBottom>
              Operators
            </Typography>
            <IconButton size="medium" color="default" onClick={handleSettingsClicked}>
              <Settings/>
            </IconButton>
          </Toolbar>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Operator Password</TableCell>
                  <TableCell>
                    {operatorSettings === undefined ? (
                        <>
                          {"LOGIN TO VIEW PASSWORD"}
                          <IconButton size="small" color="default" onClick={() => forceReload()}>
                            <Refresh/>
                          </IconButton>
                        </>
                      ) : (
                        <>
                        {operatorSettings.password}
                        </>
                      )}
                  </TableCell>
                </TableRow>
              </TableHead>
            </Table>
          </TableContainer>
          <br/>

          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Operator</TableCell>
                  <TableCell>Cube</TableCell>
                  <TableCell>Login Time</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {operatorRepository.operatorSessions.map((x) => (
                  <TableRow
                    key={`Operator_${x.cube.id}`}
                    hover
                  >
                    <TableCell>{x.name}</TableCell>
                    <TableCell>{x.cube?.name}</TableCell>
                    <TableCell>{new Date(x.createdAt).toLocaleString()}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>

        </Paper>
      </Loading>
    </>
  );
}